'use strict';

exports.__esModule = true;

var _utils = require('../utils');

var _weex = require('../fetcher/weex');

var _weex2 = _interopRequireDefault(_weex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * Created by @玩家 on 2016/11/18.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */


exports['default'] = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(ctx, next) {
        var originUrl, response, resOptions;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        if (_utils.isWeex) {
                            _context.next = 4;
                            break;
                        }

                        _context.next = 3;
                        return next();

                    case 3:
                        return _context.abrupt('return', _context.sent);

                    case 4:
                        originUrl = ctx.req.originUrl;
                        _context.next = 7;
                        return (0, _weex2['default'])(ctx.req);

                    case 7:
                        response = _context.sent;
                        resOptions = {
                            ok: false,
                            status: 404,
                            statusText: 'Not Found',
                            headers: new Headers(),
                            body: originUrl + ' Not Found'
                        };


                        resOptions = response || resOptions;
                        ctx.generateResponse(resOptions);

                        _context.next = 13;
                        return next();

                    case 13:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    function weexFetchMiddleware(_x, _x2) {
        return _ref.apply(this, arguments);
    }

    return weexFetchMiddleware;
}();

module.exports = exports['default'];